// extracted by mini-css-extract-plugin
export default {"container":"PromoCard_container__hItFu"};